module.exports = __webpack_public_path__ + "static/media/6. Esencia del espíritu, Óleo y acrílico en tela, 140 x 180 cm, 2016 copy.990959b1.png";